/** Placeholder for a contact field with no value, so table cells don't look broken. */
export function EmptyContactValue({ value }: { value?: string | null }) {
  const trimmed = value?.trim();
  if (!trimmed) {
    return <span className="text-muted-foreground">Not provided</span>;
  }
  return trimmed;
}
